<template>
  <component :is="layout">
    <transition v-if="ready" name="fade" mode="out-in">
      <router-view v-slot="{ Component, route }">
        <div v-if="Component" id="main" :key="route.path">
          <component :is="Component" />
        </div>
      </router-view>
    </transition>
  </component>

  <Popup ref="popupRef" />
  <Store ref="storeRef" />
  <Loading ref="loadingRef"></Loading>
</template>

<script setup>
import '@/css/tailwind.css';
import '@/css/main.css';
import { ref, computed, provide, onBeforeMount, watch, nextTick } from 'vue';
import { useRoute } from 'vue-router';
import Layout from "./components/Layout.vue";
import LoginLayout from "./components/LoginLayout.vue";
import Popup from '@/components/Popup.vue'
import Store from '@/components/Store.vue'
import Loading from '@/components/Loading.vue'

const route = useRoute();

const ready = ref(false);
const layout = ref({});
watch(() => route.path, async (nv, ov) => {
  switch (route.meta.layout) {
    case 'LoginLayout':
      if (layout.value != LoginLayout) { layout.value = LoginLayout; }
      break;
    default:
      if (layout.value != Layout) { layout.value = Layout; }
      break;
  }
  nextTick(async () => {
    if (layout.value != {} && ready.value == false) { ready.value = true; }
  })

}, { deep: true })

const popupRef = ref(null)
provide('popup', popupRef)

const storeRef = ref(null);
provide('store', storeRef)

const loadingRef = ref(null);
provide('loading', loadingRef)

</script>

<style>
/* 基本淡入淡出效果 */
.fade-leave-active {
  display: none;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

.fade-enter-active {
  transition: 0.5s ease;
}
</style>
